import { render } from "./AdminForceupdateCreate.vue?vue&type=template&id=1d501b3b&scoped=true&ts=true&lang=true"
import script from "./AdminForceupdateCreate.vue?vue&type=script&lang=ts"
export * from "./AdminForceupdateCreate.vue?vue&type=script&lang=ts"

import "./AdminForceupdateCreate.vue?vue&type=style&index=0&id=1d501b3b&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d501b3b"]])

export default __exports__